import { CanActivate, Router } from "@angular/router";
import { AutenticacaoService } from "./autenticacao.service";
import { Injectable } from "@angular/core";
import { map, Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
}) export class AuthGuard implements CanActivate {
  constructor(private autenticacaoService: AutenticacaoService, private router: Router) { }

  canActivate(): Observable<boolean> {
    if (this.autenticacaoService.isLoggedIn()) {
      return of(true);
    }

    // Se não está logado mas tem token, tenta renovar
    if (this.autenticacaoService.token) {
      return this.autenticacaoService.validaTokenAluno().pipe(
        map((valido) => {
          if (!valido) {
            this.autenticacaoService.logout();
          }
          return valido;
        }),
      );
    }

    // Sem token, redireciona para login
    this.autenticacaoService.logout();
    return of(false);
  }
}
